import React, { useLayoutEffect, useRef } from 'react'

interface TranzillaProps {
  chosenPlan: PlanCard
  credentials: any
  mondayAccountId: number
}

export const Tranzilla: React.FC<TranzillaProps> = ({ chosenPlan, credentials, mondayAccountId }) => {
  const formRef = useRef<HTMLFormElement | null>(null)
  useLayoutEffect(() => {
    formRef.current?.submit()
  })

  const price = chosenPlan.price * 12
  const maam = credentials.isLocal ? 17 : 0
  const json = `%5B%7B%22product_name%22%3A%22E.S.L's FreshService Integration Annual Subscription%22%2C%22product_quantity%22%3A1%2C%22product_price%22%3A${price}%7D%5D`
  const pdesc = "E.S.L's FreshService Integration"
  return (
    <>
    </>
  )
}
